import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, ArrowUpRight } from "lucide-react";

const MAIN_LOGO =
    "/assets/tc-auditors-logo-black.png";

export default function Footer() {
    return (
        <footer className="bg-tca-ink text-white" data-testid="site-footer">
            <div className="container-tca py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <div className="bg-white inline-block p-3 mb-6">
                        <img src={MAIN_LOGO} alt="TC Auditors" className="h-10 w-auto" />
                    </div>
                    <p className="text-white/70 text-sm leading-relaxed max-w-md">
                        TC Auditors (Pty) Ltd — Chartered Accountants &amp; Auditors. Established 2015. A Xero Gold Partner serving ambitious South African businesses across audit, tax, accounting, payroll and advisory.
                    </p>
                    <div className="mt-6 flex flex-wrap items-start gap-4">
                        <span className="border border-white/30 px-3 py-1.5 text-[10px] tracking-[0.2em] uppercase font-bold self-start">
                            CIPC 2015/290284/07
                        </span>
                        <div className="flex flex-col gap-2">
                            <span className="border border-tca-orange text-tca-orange px-3 py-1.5 text-[10px] tracking-[0.2em] uppercase font-bold self-start">
                                Xero Gold Partner
                            </span>
                            <img
                                src="/assets/xero-gold-partner-badge.png"
                                alt="Xero Gold Partner"
                                className="h-[98px] w-auto object-contain"
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>

                <div className="md:col-span-3">
                    <h4 className="text-white text-sm font-bold uppercase tracking-[0.2em] mb-5">Sitemap</h4>
                    <ul className="space-y-3 text-sm">
                        {[
                            ["/", "Home"],
                            ["/about", "About Us"],
                            ["/services", "Services"],
                            ["/pricing", "Pricing & Packages"],
                            ["/software", "Software & Apps"],
                            ["/checklists", "Checklists"],
                            ["/faqs", "FAQs"],
                            ["/contact", "Contact Us"],
                            ["/admin", "Admin Login"],
                        ].map(([to, label]) => (
                            <li key={to}>
                                <Link
                                    to={to}
                                    data-testid={`footer-nav-${label.toLowerCase().replace(/\s|&/g, "-")}`}
                                    className="text-white/70 hover:text-tca-orange transition-colors inline-flex items-center gap-1.5"
                                >
                                    {label} <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100" />
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <h4 className="text-white text-sm font-bold uppercase tracking-[0.2em] mb-5">Contact</h4>
                    <ul className="space-y-4 text-sm text-white/80">
                        <li className="flex items-start gap-3" data-testid="footer-address">
                            <MapPin className="w-4 h-4 mt-1 text-tca-orange shrink-0" />
                            <span>42 Boet Kruger Street<br />Meyerton, Gauteng, 1961<br />South Africa</span>
                        </li>
                        <li className="flex items-center gap-3" data-testid="footer-email">
                            <Mail className="w-4 h-4 text-tca-orange shrink-0" />
                            <a href="mailto:admin@tcauditors.co.za" className="hover:text-tca-orange transition-colors">admin@tcauditors.co.za</a>
                        </li>
                        <li className="flex items-center gap-3" data-testid="footer-phone-reception">
                            <Phone className="w-4 h-4 text-tca-orange shrink-0" />
                            <span><span className="text-white/50 mr-2">Reception</span><a href="https://wa.me/27794617545" target="_blank" rel="noopener noreferrer" className="hover:text-tca-orange transition-colors">079 461 7545</a><span className="ml-2 text-[9px] font-bold text-green-400 border border-green-500/40 px-1.5 py-0.5 rounded">WA</span></span>
                        </li>
                        <li className="flex items-center gap-3" data-testid="footer-phone-backoffice">
                            <Phone className="w-4 h-4 text-tca-orange shrink-0" />
                            <span><span className="text-white/50 mr-2">Back Office</span><a href="https://wa.me/27826993003" target="_blank" rel="noopener noreferrer" className="hover:text-tca-orange transition-colors">082 699 3003</a><span className="ml-2 text-[9px] font-bold text-green-400 border border-green-500/40 px-1.5 py-0.5 rounded">WA</span></span>
                        </li>
                        <li className="flex items-center gap-3" data-testid="footer-phone-helpdesk">
                            <Phone className="w-4 h-4 text-tca-orange shrink-0" />
                            <span><span className="text-white/50 mr-2">Help Desk</span><a href="tel:0600151110" className="hover:text-tca-orange transition-colors">060 015 1110</a></span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="container-tca py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-xs text-white/50">
                    <span>© {new Date().getFullYear()} TC Auditors (Pty) Ltd. All rights reserved.</span>
                    <span className="tracking-[0.18em] uppercase">Established 2015 · CA(SA) · RA · Xero Gold Partner</span>
                </div>
            </div>
        </footer>
    );
}
